import WpPage, { getWpInitialProps } from "components/wpPage/WpPage";
import PrintOnDemandForWix from "containers/wpPage/print-on-demand-for-wix";

export default function PrintOnDemandForWixPage() {
  return (
    <WpPage seoKey="print-on-demand-for-wix">
      <PrintOnDemandForWix />
    </WpPage>
  );
}

PrintOnDemandForWixPage.getInitialProps = getWpInitialProps;
